export default __webpack_public_path__ + "static/media/Icon feather-chevron-right.3ee23ff0.svg";